import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import React from 'react';
import IconCheck from '@/assets/icons/heroIcons/Check.svg';
import { ContentContainer } from '@/components/layout';
import { Text } from '@/components/typography';
import { Link } from '@/components/links';
interface BenefitItemsProps {
  background?: 'bg-white' | 'bg-blue-50';
  height?: 'default' | 'large';
  classNameItem?: string;
  classNameTitle?: string;
  items: {
    title: string | React.ReactNode;
    subtitle?: string | React.ReactNode;
    icon?: React.ReactNode;
    to?: string;
    analyticsParam?: string;
    testId?: string;
  }[];
  className?: string;
}
export function BenefitTiles(t0) {
  const $ = _c(16);
  const {
    background,
    className,
    height: t1,
    classNameItem,
    classNameTitle,
    items
  } = t0;
  const height = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = mergeClasses("flex flex-wrap items-center justify-center gap-2 md:px-4 lg:gap-4 xl:px-0", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== background || $[3] !== classNameItem || $[4] !== classNameTitle || $[5] !== height || $[6] !== items) {
    let t4;
    if ($[8] !== background || $[9] !== classNameItem || $[10] !== classNameTitle || $[11] !== height) {
      t4 = (t5, index) => {
        const {
          title,
          subtitle,
          icon,
          to,
          analyticsParam,
          testId
        } = t5;
        const tileClassName = mergeClasses("w-[30rem] max-w-full rounded-2xl p-3 pr-5 lg:p-4", {
          "md:h-24": height === "default",
          "md:h-28": height === "large"
        }, icon ? "pl-3 lg:pl-4" : "pl-5", background || "bg-white", classNameItem);
        const content = <div className="flex h-full items-center gap-4 lg:gap-5"><div className={mergeClasses("flex shrink-0 items-center justify-center", !icon && "h-10 w-10 rounded-full bg-green-100/10")}>{icon || <IconCheck className="h-8 w-8 text-green-500" />}</div><div className={mergeClasses("flex flex-col", subtitle ? "items-start" : "")}><Text variant="p2" className={subtitle ? "font-semibold" : classNameTitle}>{title}</Text>{subtitle && <Text variant="p3" className="text-left text-sm">{subtitle}</Text>}</div></div>;
        if (to && analyticsParam && testId) {
          return <Link key={index} to={to} analyticsParam={analyticsParam} testId={testId} className={mergeClasses(tileClassName, "block text-gray-900 no-underline hover:text-gray-900")}>{content}</Link>;
        }
        return <div key={index} className={tileClassName}>{content}</div>;
      };
      $[8] = background;
      $[9] = classNameItem;
      $[10] = classNameTitle;
      $[11] = height;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    t3 = items.map(t4);
    $[2] = background;
    $[3] = classNameItem;
    $[4] = classNameTitle;
    $[5] = height;
    $[6] = items;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <ContentContainer><div className={t2}>{t3}</div></ContentContainer>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}